import React from 'react';
import spirit from 'spiritjs';
import {TweenMax, TimelineMax} from "gsap";
import { Header, Main, Footer } from './Body';

const Loading = (props) => (
  <div className="loading-screen" style={{ display: props.display }}>
    <svg overflow="visible" width="44" height="44" xmlns="http://www.w3.org/2000/svg" version="1.1">
      <circle id="#loader" cx="22" cy="22" r="22" fill="none"></circle>
    </svg>
  </div>
)

export class App extends React.Component {
  constructor() {
    super();
    this.state = {
      loadingDisplay: 'flex',
      logoDisplay: 'none',
      logoClass: 'logo'
    };
    spirit.setup({
     tween: TweenMax,
     timeline: TimelineMax
   });
  }

  componentDidMount () {
    this.setState({
      loadingDisplay: 'none',
      logoDisplay: 'block',
      logoClass: 'logo logo-animat'
    });
  }

  render () {
    return (
      <div>
        <Loading display={this.state.loadingDisplay} />
        <Header logoDisplay={this.state.logoDisplay} logoClass={this.state.logoClass} />
        <Main />
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js